import React from 'react';
import { motion, useScroll, useSpring, useReducedMotion } from 'framer-motion';
import './ScrollProgress.css';

const ScrollProgress = () => {
  const prefersReducedMotion = useReducedMotion();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001
  });

  if (prefersReducedMotion) {
    return null;
  }

  return (
    <motion.div
      className="scroll-progress"
      style={{ scaleX }}
      aria-hidden="true"
    />
  );
};

export default ScrollProgress;
